export default "__VITE_ASSET__$m75nK3F__"